import alertIcon from '@iconify/icons-ant-design/alert-outline';
import ellipsisIcon from '@iconify/icons-ant-design/ellipsis-outline';
import expandIcon from '@iconify/icons-ant-design/fullscreen-outline';
import infoCircleIcon from '@iconify/icons-ant-design/info-circle-outline';
import hideIcon from '@iconify/icons-ant-design/minus-circle-outline';
import percentageIcon from '@iconify/icons-ant-design/percentage-outline';
import { IconSm, IconTiny } from '@/widgets/components/icon';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import React from 'react';
import { Dropdown as RsDropdown } from 'rsuite';
import { useTransientOccupancyTaxName } from '@/hooks/useTaxName';
import styled from 'styled-components';

// these strings will be used
const defaultDropdownOptVisibility = {
  info: true,
  expand: true,
  hide: true,
  adjustTOT: false,
  reportErr: false,
};

const StyledIcon = styled(IconSm)`
  color: rgba(0, 0, 0, 0.5);
`;

const Wrapper = styled(InvisibleButton)`
  padding: 0;
  margin: 0;
  // position: absolute;
  // right: 0;
`;

const StyledRsDropdownItem = styled(RsDropdown.Item)`
  .rs-modal-sm {
    margin: 10% 15% 0 15%;
  }
  .rs-dropdown-item-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

const DropdownItem = ({ icon, txt, onClick }) => (
  <StyledRsDropdownItem icon={<IconTiny icon={icon} />} onClick={onClick}>
    &nbsp;{txt}
  </StyledRsDropdownItem>
);

// +optionable turns optionable into a number. Circumvents styled-comp boolean prop warning
export function HeaderDropdown({ show, optionsOverride, onClickHandlers }) {
  const totAlias = useTransientOccupancyTaxName();

  if (!show) return null;

  const options = { ...defaultDropdownOptVisibility, ...optionsOverride };

  return (
    <Wrapper onClick={(evt) => evt.stopPropagation()}>
      <RsDropdown
        renderTitle={() => <StyledIcon icon={ellipsisIcon} />}
        placement="bottomEnd"
      >
        {options.info && (
          <DropdownItem
            icon={infoCircleIcon}
            txt="Information"
            onClick={() => onClickHandlers.info()}
          />
        )}
        {options.expand && (
          <DropdownItem
            icon={expandIcon}
            txt="Expand"
            onClick={() => onClickHandlers.expand()}
          />
        )}
        {options.hide && (
          <DropdownItem
            icon={hideIcon}
            txt="Hide"
            onClick={() => onClickHandlers.hide()}
          />
        )}
        {options.adjustTOT && (
          <DropdownItem icon={percentageIcon} txt={`Adjust ${totAlias} Rate`} />
        )}
        {options.reportErr && (
          <DropdownItem icon={alertIcon} txt="Report Error" />
        )}
      </RsDropdown>
    </Wrapper>
  );
}
